<template>
  <div class="translate-wrapper">
    <ValidationObserver
      ref="validationObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="contact-info"
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <MaterialInput
          v-model="formData.name"
          v-bind="formFields.name"
        />
        <div class="btn-wrapper">
          <div class="btn-wrapper-b">
            <Button
              type="submit"
              :title="'Apply Changes'"
              :classType="'primary'"
            />
            <Button
              :title="'Revert'"
              :classType="'warning'"
              :eventFunction="revertLanguage"
            />
          </div>
          <div
            v-if="isEditedForm.length
              && isEditedForm.find(item => item.id === lang.id && !!item.value)"
            class="changes-wrapper"
          >
            <inline-svg
              :src="iconChanges"
              class="svg-icon"
            >
            </inline-svg>
            <span class="changes-text">
              Unsaved changes
            </span>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseForm from '../BaseForm.vue';
import Button from '../../common/Button.vue';
import MaterialInput from '../../inputs/MaterialInput.vue';
import iconChanges from '../../../assets/icons/icon-localization-changes.svg';

import {
  ADD_LANGUAGE_GENRES_REQUEST,
  GET_LANGUAGE_GENRES_REQUEST,
  INIT_FORM_CHANGES,
  SET_FORM_CHANGES,
} from '../../../store/actions/localization/localizationActions';

export default {
  name: 'GenreLocalizationForm',
  components: {
    Button,
    MaterialInput,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'genreLocalization',
    },
    lang: {
      type: Object,
      default: () => {},
    },
    genre: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    changedLanguage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      iconChanges,
      submitEvent: ADD_LANGUAGE_GENRES_REQUEST,
      successMessages: `The ${this.lang.name} Localization has been successfully updated`,
      formData: {
        name: '',
      },
      formFields: {
        name: {
          type: 'text',
          name: 'name',
          label: 'Name',
          formPrefix: this.formPrefix,
          rules: {
            required: false,
            max: 255,
          },
        },
      },
      errorMapping: {
        name: [
          `${this.formPrefix}.name`,
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isEditedForm: (state) => state.localization.isEditedForm,
    }),
    ...mapGetters([
      'getCurrentAccountId',
      'isThemeBasic',
    ]),
  },
  created() {
    const value = this.languages.map(((item) => ({
      id: item.id,
      value: false,
    })));
    this.$store.dispatch(INIT_FORM_CHANGES, value);

    const params = {
      accountId: this.getCurrentAccountId,
      genreId: this.genre && this.genre.id,
      langId: this.lang.id,
    };
    this.$store.dispatch(GET_LANGUAGE_GENRES_REQUEST, params).then((res) => {
      this.initFormData(res);
    });
  },
  beforeDestroy() {
    this.$store.dispatch(SET_FORM_CHANGES, []);
  },
  methods: {
    initFormData(data) {
      this.formData.name = data.name;
    },
    handleFormChange() {
      this.$emit('changedLanguage', { id: this.lang.id, value: true });
    },
    revertLanguage() {
      const params = {
        accountId: this.getCurrentAccountId,
        genreId: this.genre && this.genre.id,
        langId: this.lang.id,
      };
      this.$store.dispatch(GET_LANGUAGE_GENRES_REQUEST, params).then((res) => {
        this.$emit('changedLanguage', { id: this.lang.id, value: false });
        this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
        this.initFormData(res);
      });
    },
    getRequestData() {
      const data = {
        name: this.formData.name,
      };

      return {
        accountId: this.getCurrentAccountId,
        genreId: this.genre && this.genre.id,
        langId: this.lang.id,
        data,
      };
    },
    onSubmitSuccess() {
      this.$emit('changedLanguage', { id: this.lang.id, value: false });
      this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
      this.$toasted.global.success({
        message: this.successMessages,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding-top: 35px;
}

.changes-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #FB3951;
  border-radius: 2px;
  padding: 8px;
  color: #FB3951;
  margin-left: 20px;
}

.changes-text {
  padding-left: 5px;
}

.btn-wrapper-b {
  display: flex;
}
</style>
